<template>
    <div class="text-13px text-warm-grey-two flex justify-end space-x-2">
        <div v-if="hasComments" 
            class="flex items-center">
            <img :src="CDN_GET('assets/mhr/icons/icon-listing-comment-2.svg')  + '?v=2'" 
                width="16" 
                alt="comment icons" />
            <span class="ml-1">{{ article.comment_count }}</span>
        </div>

        <div class="flex items-center">
            <img :src="CDN_GET('assets/mhr/icons/icon-listing-time.svg') + '?v=2'" 
                width="16" 
                alt="time icon" />
            <span class="ml-1 w-full">{{ articleDate }}</span>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        article: {
            type: Object
        },
        feelings: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        hasComments() {
            return undefined !== this.article.comment_count &&
                null !== this.article.comment_count &&
                0 < this.article.comment_count
        },
        articleDate() {
            return this.article.human_time
        }
    }
}
</script>